import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useCurrentCategoryPage } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/currentCategoryPageContext";
import { logAssert } from "@faire/web--source/common/logging";
export var useCurrentNavigationPath = function() {
    var _useCurrentCategoryPage = _sliced_to_array(useCurrentCategoryPage([
        "navigationPath"
    ]), 1), navigationPath = _useCurrentCategoryPage[0].navigationPath;
    logAssert(!!navigationPath, "Navigation path should be defined when you access it in a category page.");
    return navigationPath;
};
